"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var ui_components_1 = require("@l2p/ui-components");
var types_1 = require("../../../../types");
var next_intl_1 = require("next-intl");
var styles_module_scss_1 = __importDefault(require("../styles.module.scss"));
var RangeStepSlider_1 = __importDefault(require("../../RangeStepSlider"));
var Step1 = function (_a) {
    var type = _a.type, setNextStep = _a.setNextStep, onChangeLimitDurationHandler = _a.onChangeLimitDurationHandler, onChangeLimitAmountHandler = _a.onChangeLimitAmountHandler, limitAmount = _a.limitAmount, limitDuration = _a.limitDuration, amountLimitsOptions = _a.amountLimitsOptions, durationLimitsOptions = _a.durationLimitsOptions;
    var t = (0, next_intl_1.useTranslations)('translation');
    var title = (0, react_1.useMemo)(function () {
        return type === types_1.LimitType.BET
            ? t('wageringLimit')
            : type === types_1.LimitType.LOSS
                ? t('lossLimit')
                : t('depositLimit');
    }, [type, t]);
    var description = (0, react_1.useMemo)(function () {
        return type === types_1.LimitType.BET
            ? t('wageringLimitDescription')
            : type === types_1.LimitType.LOSS
                ? t('lossLimitDescription')
                : t('depositLimitDescription');
    }, [type, t]);
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.title }, title),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.description }, description),
        react_1.default.createElement(ui_components_1.InputText, { name: "amount", value: String(limitAmount), type: "number", onChange: function (e) {
                // if (!isNaN(Number(e.target.value)) && e.target.value.trim() !== '')
                onChangeLimitAmountHandler(Number(e.target.value));
            }, placeholder: t('inputAmount'), labelText: t('amount') }),
        react_1.default.createElement("br", null),
        react_1.default.createElement(RangeStepSlider_1.default, { title: t('durationPeriod'), value: "".concat(durationLimitsOptions[limitDuration] || ''), onChangeHandler: onChangeLimitDurationHandler, initialValue: limitDuration, marks: durationLimitsOptions }),
        react_1.default.createElement(ui_components_1.FixedButton, { color: "gradient", text: "upper", onClick: function () {
                if (limitAmount && limitAmount !== 0)
                    setNextStep();
            }, disabled: !limitAmount || limitAmount === 0, maxWidth: "335px", width: "100%" }, t('submit'))));
};
exports.default = Step1;
